var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{directives:[{name:"show",rawName:"v-show",value:(_vm.displayStamp),expression:"displayStamp"}],staticClass:"verification-stamp",class:_vm.getStampClass,style:(_vm.getStampSize)},[_c('use',{attrs:{"xlink:href":_vm.getStampIcon}})])
}
var staticRenderFns = []

export { render, staticRenderFns }